import React, {useState} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from "@material-ui/core/IconButton";
import SettingsIcon from "@material-ui/icons/Settings";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined';
import ListItem from "@material-ui/core/ListItem";
import usePersistentStore from "../../persistentStore";
import * as STATES from "../../constants/states";
import {useHistory} from 'react-router-dom';
import FeedbackIcon from '@material-ui/icons/Feedback';
import FeedbackDialog from "../../dialogs/feedback";
import DownloadExtensionDialog from "../../dialogs/downloadExtension";
import GetAppIcon from '@material-ui/icons/GetApp';
import Divider from "@material-ui/core/Divider";
import FaceIcon from '@material-ui/icons/Face';

// TODO low - Index - move menu to left

const inIFrame = (window.parent.window !== window);

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})(props => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles(theme => ({
    root: {
        paddingTop: 0,
        paddingBottom: 0,
    },
}))(MenuItem);

export default function SettingsMenu() {
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [anchorEl, setAnchorEl] = useState(null);
    const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
    const [downloadExtensionDialogOpen, setDownloadExtensionDialogOpen] = useState(false);
    const history = useHistory();

    const handleFeedbackDialogOpen = () => {
        setFeedbackDialogOpen(true);
    };

    const handleFeedbackDialogClose = () => {
        setFeedbackDialogOpen(false);
    };

    const handleDownloadExtensionDialogOpen = () => {
        setDownloadExtensionDialogOpen(true);
    };

    const handleDownloadExtensionDialogClose = () => {
        setDownloadExtensionDialogOpen(false);
    };

    const handleMenuClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    function ListItemLink(props) {
        return <ListItem button component="a" {...props} />;
    }

    return (
        <>
            <IconButton
                aria-controls="gear-menu"
                aria-haspopup="true"
                color="inherit"
                aria-label="Settings"
                onClick={handleMenuClick}
            >
                <SettingsIcon/>
            </IconButton>
            <StyledMenu
                id="gear-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                {!inIFrame && globalPersistentState.me && <StyledMenuItem>
                    <ListItemIcon>
                        <FaceIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText
                        id='gear-profile'
                        name='gear-profile'
                        aria-label='gear-profile'
                        style={{padding: 0, paddingRight: 0}}
                        primary={globalPersistentState.me.displayName}
                        onClick={() => {
                            handleMenuClose();
                            console.log('## SVR settingsMenu ## changing history', '/settings/profile');
                            history.push('/settings/profile');
                        }}
                    >
                    </ListItemText>
                </StyledMenuItem>}
                <StyledMenuItem>
                    <ListItemIcon>
                        <LinkOutlinedIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemLink
                        id='gear-install-ext'
                        name='gear-install-ext'
                        aria-label='gear-install-ext'
                        href={process.env.REACT_APP_CHROME_INSTALL}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            handleMenuClose();
                        }} style={{padding: 0, paddingRight: 0}}
                    >
                        <ListItemText
                            primary="Install Chrome Extension"
                        />
                    </ListItemLink>
                </StyledMenuItem>
                <StyledMenuItem>
                    <ListItemIcon>
                        <FeedbackIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText
                        id='gear-feedback'
                        name='gear-feedback'
                        aria-label='gear-feedback'
                        primary="Send Feedback"
                        onClick={() => {
                            handleMenuClose();
                            handleFeedbackDialogOpen();
                        }}
                    />
                </StyledMenuItem>
                {inIFrame && (<StyledMenuItem>
                    <ListItemIcon>
                        <LinkOutlinedIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemLink
                        id='gear-junctionbox'
                        name='gear-junctionbox'
                        aria-label='gear-junctionbox'
                        href={process.env.REACT_APP_HOME_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            handleMenuClose();
                        }} style={{padding: 0, paddingRight: 0}}
                    >
                        <ListItemText
                            primary="Go to JunctionBox.io"
                        />
                    </ListItemLink>
                </StyledMenuItem>)}
                <Divider/>
                <StyledMenuItem>
                    <ListItemIcon>
                        <LockOutlinedIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText
                        primary="Sign Out"
                        id='gear-sign-out'
                        name='gear-sign-out'
                        aria-label='gear-sign-out'
                        onClick={() => {
                            globalPersistentActions.setState(STATES.LOGGING_OUT);
                            handleMenuClose();
                        }}
                    />
                </StyledMenuItem>
            </StyledMenu>
            <FeedbackDialog open={feedbackDialogOpen} handleClose={handleFeedbackDialogClose} whatNot={"standard"}/>
            <DownloadExtensionDialog open={downloadExtensionDialogOpen}
                                     handleClose={handleDownloadExtensionDialogClose}/>
        </>
    );
}
